import Modal from "react-modal"
import clsx from "clsx"
import { useCallback, useContext, useEffect, useState } from "react"
import { globalStoreContext } from "src/store/GlobalStore"
import { Novel } from "src/models/tieup/novel/Novel"
import Link from "next/link"
import routes from "routes"
import NovelContent from "./content"
import Creator from "./creator"

type Props = {
  novel: Novel | null
  onClose: () => void
}

const NovelDetail: React.FC<Props> = ({ novel, onClose }) => {
  const { globalDispatch } = useContext(globalStoreContext)

  const [page, setPage] = useState("novel")

  useEffect(() => {
    globalDispatch({ type: "scrollLock", payload: !!novel })
  }, [globalDispatch, novel])

  const changePage = useCallback(() => {
    if (page === "novel") {
      setPage("profile")
    } else {
      setPage("novel")
    }
  }, [page])

  if (!novel) return null

  return (
    <Modal
      className="p-modal"
      overlayClassName={clsx({
        "p-modal-overlay": true,
        "is-show": true,
      })}
      isOpen={!!novel}
    >
      <div className="p-simplified-wrapper">
        <div className="p-simplified">
          <button
            className="c-close-button p-simplified-close js-simplified-close"
            onClick={() => onClose()}
          >
            <span className="c-close-button-icon"></span>
            <span className="c-close-button-label">閉じる</span>
          </button>

          <button
            className={clsx({
              "slick-next": page === "novel",
              "slick-prev": page === "profile",
              "slick-arrow": true,
            })}
            type="button"
            onClick={() => changePage()}
          ></button>

          {page === "novel" && <NovelContent novel={novel} onClose={onClose} />}
          {page === "profile" && !!novel.user && <Creator user={novel.user} />}

          <ul className="p-novelSimplified-link p-linkList">
            <li>
              <Link href={routes.creatorNovelsDetail(novel.id)}>
                <a
                  onClick={() => onClose()}
                  className="p-novelSimplified-link-anchor p-linkList-anchor"
                >
                  概要を見る
                </a>
              </Link>
            </li>
            {novel.chapters && novel.chapters[0] && (
              <li>
                {/* 表紙のない Novel なので最初の章に遷移させる */}
                <Link
                  href={routes.viewerText(
                    novel.id,
                    novel.chapters[novel.chapters.length - 1].id,
                  )}
                >
                  <a
                    className="p-novelSimplified-link-anchor p-linkList-anchor"
                    target="_blank"
                  >
                    小説を読む
                  </a>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    </Modal>
  )
}

export default NovelDetail
